// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".delivery-schedule .flat-date-picker[data-v-579118a8]{-webkit-box-shadow:unset!important;box-shadow:unset!important;border:1px solid var(--primaryColor);border-radius:0 0 5px 5px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
